export default __webpack_public_path__ + "cb05da83e8fcf40c1c868ca15ee68005.webp";